import * as Sentry from '@sentry/react';
import { toast } from 'sonner';

import { enhancedApi as templatesV2Service } from '@/services/api/generated/templatesV2Service';
import { store } from '@/state/state';

export const downloadTemplate = async (templateId: string, name: string) => {
  try {
    const template = await store
      .dispatch(
        templatesV2Service.endpoints.templateRetrieve.initiate({
          id: templateId,
        }),
      )
      .unwrap();

    const templateUrl = template.file_url;
    const fileExtension = template.format?.toLowerCase() || 'docx';

    if (!templateUrl) {
      throw new Error('Template URL not available');
    }

    const response = await fetch(templateUrl);
    if (!response.ok) {
      throw new Error('Failed to download template');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name}.${fileExtension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.success('Template downloaded successfully');
  } catch (error) {
    toast.error('Failed to download template');
    Sentry.captureException(error, {
      tags: { operation: 'download_template', templateId },
    });
  }
};
